/*
 *  @providesModule DepositOfferTileStyles
 *
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {StyleSheet, Platform} from 'react-native';

const {
  fontSizeVeryLarge,
  fontSizeLarge,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH5,
  fontMedium,
  fontSecondary,
  textColorDepositTile,
  textShadowTwo,
  viewCornerRadiusPrimary,
  viewBoxShadowPrimary,
  btnGradientStore,
} = SkillzStyle.fullStyles;

const kStarWidth = 40;
const styles = StyleSheet.create({
  bottomSection: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 4,
    backgroundColor: 'transparent',
    height: '40%',
  },

  bottomText: {
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    textAlignVertical: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeH3.fontSize,
      xxlg: fontSizeH2.fontSize,
    }),
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  checkContainer: {
    position: 'absolute',
    left: 10,
    top: 10,
    width: 30,
    height: 30,
  },

  check: {
    flexGrow: 1,
  },

  contentBox: {
    position: 'absolute',
    flexGrow: 1,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },

  depositBox: {
    flexGrow: 1,
    marginVertical: 2,
    marginHorizontal: 3,
  },

  divider: {
    height: 1,
    backgroundColor: SkillzStyle.convertToOpacity(btnGradientStore[0], 0.8),
    ...viewBoxShadowPrimary,
  },

  gradient: {
    flex: 1,
    overflow: 'hidden',
    borderRadius: 4,
    borderWidth: 2,
    backgroundColor: btnGradientStore[0],
    borderColor: btnGradientStore[0],
    marginTop: 1,
    marginBottom: 1,
  },

  hr: {
    opacity: 0.8,
    height: 1.5,
    backgroundColor: btnGradientStore[0],
    borderWidth: 0,
    width: '100%',
  },

  hrShadow: {
    opacity: 0.3,
    height: 1,
    backgroundColor: 'black',
    borderWidth: 0,
    width: '100%',
  },

  leftText: {
    backgroundColor: 'transparent',
    alignSelf: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeLarge.fontSize,
      xxlg: fontSizeVeryLarge.fontSize,
    }),
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  rightText: {
    backgroundColor: 'transparent',
    alignSelf: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeH2.fontSize,
      xxlg: fontSizeH1.fontSize,
    }),
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  star: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: kStarWidth,
    height: kStarWidth,
  },

  starContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    alignSelf: 'center',
    marginTop: 4,
  },

  starContainerExtraLarge: {
    flexGrow: 1,
    justifyContent: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
  },

  starContainerWideRight: {
    justifyContent: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
    flexGrow: 1,
  },

  starContainerWideLeft: {
    justifyContent: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
    flexGrow: 1,
  },

  titleContainer: {
    flexGrow: 1,
    marginTop: 10,
  },

  titleStyle: {
    textAlign: 'center',
    backgroundColor: 'transparent',
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  primaryStyle: {
    ...Platform.select({
      android: {},
      ios: {
        marginHorizontal: 4,
        paddingHorizontal: 4,
      },
    }),
    textAlign: 'center',
    backgroundColor: 'transparent',
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  topSection: {
    flexGrow: 1,
    alignSelf: 'stretch',
    paddingHorizontal: 6,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: '60%',
  },

  hrContainer: {
    flex: 1,
    justifyContent: 'center',
    alignSelf: 'stretch',
  },

  topText: {
    backgroundColor: 'transparent',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    ...Sizes.select({
      phone: {
        fontSize: fontSizeH1.fontSize,
      },
      other: {
        fontSize: fontSizeLarge.fontSize,
      },
    }),
    ...textShadowTwo,
    ...textColorDepositTile,
    ...fontSecondary,
  },

  wideContentBox: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    ...viewCornerRadiusPrimary,
  },

  wideTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  alignSelfCenter: {
    alignSelf: 'center',
  },

  alignItemsCenter: {
    alignItems: 'center',
  },
  badgeContainer: {
    position: 'absolute',
    top: -3,
    right: -3,
    height: 19,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#FFD208',
    backgroundColor: '#FFE600',
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  badgeText: {
    ...fontSizeH5,
    color: 'black',
  },

  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export {styles as default};
